import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const Background = styled(Box)({
    width: '100%',
    height: '100%',
    backgroundColor: 'var(--dark-purple)',
})
